"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Link from "next/link";
import "../AutoVerkaufen.css";

import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";
import { TopSectionAutoVerkaufen } from "../sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";
import höchstenPreis from "@/assets/auto-verkaufen/wir-kaufen-dein-auto-verkauf.avif";
import vonZuhauseAus from "@/assets/auto-verkaufen/Verkauft-handy.avif";
import { fragenBurgenland } from "../data";
import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";

// Only needed after step 11; keep auth-related code/CSS out of initial paint.
// Below-the-fold section; defer to reduce initial route JS/CSS.
const Ratgeber = dynamic(() => import("@/components/Ratgeber/Ratgeber"), {
  ssr: false,
});

const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function Burgenland() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionAutoVerkaufen
        title={<>Auto im Burgenland verkaufen: So bekommst du den Bestpreis</>}
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung für das Burgenland.
          </>
        }
        buttonTitle="Bewertung ansehen"
        linkname="Burgenland"
        link="/auto-verkaufen/burgenland"
        customNav="Auto verkaufen"
        customNavLink="/auto-verkaufen"
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen/burgenland"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color AV-below-fold">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Du möchtest dein Auto im Burgenland verkaufen?"
              leftText={
                <>
                  <p>
                    Egal ob in Eisenstadt, Oberwart, Neusiedl am See oder in
                    einer kleinen Gemeinde, der Verkauf kann schnell zur
                    Herausforderung werden. Viele Pendler und Familien fahren
                    täglich nach Wien oder Graz, dazu kommen Studenten und
                    Selbstständige. Kleinwagen für den Alltag sind gefragt,
                    ebenso praktische Kombis. Gleichzeitig ist der Privatverkauf
                    oft mühsam, kostet Zeit und bringt Unsicherheit.
                  </p>
                  <p>
                    Mit Autoeinfachlos findest du eine schnelle, faire und
                    unkomplizierte Lösung. Dein Auto wird ohne Stress verkauft,
                    egal ob mit Motorschaden, Unfallschaden oder als gepflegter
                    Gebrauchtwagen.
                  </p>
                </>
              }
              rightFirstTitle="Auto verkaufen im Burgenland – worauf kommt es an"
              rightFirstText={
                <>
                  <p>
                    Der regionale Markt hat Besonderheiten. Viele Fahrzeuge haben
                    durch Pendlerstrecken hohe Kilometerstände. Klein- und
                    Mittelklassewagen sind stark nachgefragt, SUVs etwas weniger.
                    Durch die Nähe zu Ungarn und zur Slowakei spielt auch der
                    Export eine Rolle.
                  </p>
                  <p>
                    Die größten Probleme beim Privatverkauf sind Zeitaufwand, die
                    richtige Preisfindung und unsichere Käufer.
                  </p>
                  <h3>Dein Vorteil mit Autoeinfachlos im Burgenland</h3>
                  <p>Mit Autoeinfachlos sparst du dir den Stress beim Autoverkauf.</p>
                  <ul className="custom-unordered-list">
                    <li>Zugang zu über 5.000 geprüften Händlern</li>
                    <li>
                      Faire Preise durch Auktionen statt mühsamer
                      Einzelverhandlungen
                    </li>
                    <li>Abholung direkt bei dir im Burgenland</li>
                    <li>Sichere und schnelle Bezahlung</li>
                  </ul>
                </>
              }
              rightSecondTitle="Autoankauf im Burgenland – privat oder Händler"
              rightSecondText={
                <>
                  <p>
                    Viele Autobesitzer fragen sich, ob sie privat verkaufen oder
                    an einen Händler.
                  </p>
                  <p>
                    Privatverkauf bedeutet viel Aufwand: Inserate schreiben,
                    Termine koordinieren, Probefahrten organisieren. Die Zahlung
                    ist oft unsicher.
                  </p>
                  <p>
                    Beim Verkauf über das Händlernetzwerk erhältst du geprüfte
                    Käufer, einen transparenten Ablauf und eine sichere
                    Bezahlung.
                  </p>
                </>
              }
            />

            <div className="Banner-sections">
              <BildTextInfo
                image={höchstenPreis}
                h2
                isBig
                fontSize="36px"
                title="Was ist dein Auto im Burgenland wert?"
                alt="Auto im Burgenland bewerten"
                text={
                  <>
                    <p>
                      Der Wert hängt von mehreren Faktoren ab. Marke, Modell,
                      Baujahr, Kilometerstand und Zustand sind entscheidend. Auch
                      die regionale Nachfrage beeinflusst den Preis.
                    </p>
                    <p>
                      Mit der kostenlosen Fahrzeugbewertung erfährst du sofort,
                      welchen Preis dein Auto im Burgenland erzielen kann.
                    </p>
                    <p>
                      <Link className="link" href="/auto-bewerten">
                        Jetzt Auto bewerten
                      </Link>
                    </p>

                    <h3>So funktioniert der Verkauf im Burgenland</h3>
                    <ul className="custom-unordered-list">
                      <li>Auto online bewerten lassen – kostenlos und unverbindlich.</li>
                      <li>
                        Auktion starten – Dein Auto wird in unserem Händlernetzwerk
                        präsentiert.
                      </li>
                      <li>
                        Höchstgebot erhalten – mehrere Händler bieten, du
                        entscheidest.
                      </li>
                      <li>
                        Abholung vor Ort im Burgenland – Dein Auto wird direkt bei
                        dir im Burgenland übernommen.
                      </li>
                      <li>Sichere Bezahlung – schnell und unkompliziert.</li>
                    </ul>
                    <p>
                      Damit sparst du Zeit, verhinderst unnötigen Stress und
                      erhältst den besten Preis für dein Fahrzeug.
                    </p>
                  </>
                }
              />
            </div>

            <HäufigeFragen
              title="Häufige Fragen zum Autoverkauf im Burgenland"
              fragen={fragenBurgenland}
              image={FAQImage}
            />

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Auto verkaufen in Burgenland"
                autoVerkaufen
                autoBewerten
                listenpreisBerechnen
                fahrgestellnummerPruefen
                kaputtesAuto
                wasistmeinautowert
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={vonZuhauseAus}
                h2
                isBig
                fontSize="36px"
                title="Auto verkaufen in Burgenland leicht gemacht"
                alt="Auto verkaufen im Burgenland leicht gemacht"
                text={
                  <>
                    <p>
                      Ob Kleinwagen in Eisenstadt, Unfallauto in Oberwart oder
                      Pendlerauto in Mattersburg – mit Autoeinfachlos verkaufst
                      du dein Auto im Burgenland schnell, sicher und ohne Risiko.
                    </p>
                    <p>Starte jetzt mit der kostenlosen Fahrzeugbewertung.</p>
                    <p>
                      <Link className="link" href="/auto-bewerten">
                        Auto kostenlos bewerten
                      </Link>
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-bewerten"
            title="Jetzt Auto kostenlos bewerten und verkaufen"
          />
        </div>
      )}
    </div>
  );
}

export default Burgenland;
